import React from 'react';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES, WhiteModal } from '@sm360/widget-commons-general';

import SaveConfirmationContent from 'login/components/SaveConfirmation/SaveConfirmationContent/SaveConfirmationContent.jsx';

import MediaQuery from 'react-responsive';

import { SAVE_CONFIRMATION as MODAL } from 'login/constants/modalNames.js';

import 'login/components/SaveConfirmation/SaveConfirmationModal.scss';

const czGroupName = 'widget.login.forms.signup';
const SaveConfirmationModal = () => {
    const modalBackgroundImageUrl =
        ContentZonesService.getContentZone(czGroupName, 'background') &&
        ContentZonesService.getContentZone(czGroupName, 'background').getValue();

    return (
        <WhiteModal
            name={MODAL}
            contentLabel="trade-in saving confirmation"
            className="widget-save-confirmation-popupElement"
            isScrollable
            isClosable
            backgroundImage={modalBackgroundImageUrl}
        >
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <SaveConfirmationContent classParam="is-scrollable" />
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                <SaveConfirmationContent />
            </MediaQuery>
        </WhiteModal>
    );
};

SaveConfirmationModal.displayName = 'SaveConfirmationModal';

export default SaveConfirmationModal;
